import './NavLink.css';

function NavLink({ href, children, isActive, onClick }) {
  return (
    <a
      href={href}
      className={`nav-link ${isActive ? 'nav-link--active' : ''}`}
      onClick={onClick}
    >
      {children}
    </a>
  );
}

export default NavLink;
